// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import styled from "styled-components";

import { typography } from "../../styles";

export const Header88 = styled.div`
  ${typography.Header88}
`;
Header88.displayName = "Header88";

export const Header56 = styled.div`
  ${typography.Header56}
`;
Header56.displayName = "Header56";

export const Header34 = styled.div`
  ${typography.Header34}
`;
Header34.displayName = "Header34";

export const Header24 = styled.div`
  ${typography.Header24}
`;
Header24.displayName = "Header24";

export const Body48 = styled.div`
  ${typography.Body48}
`;
Body48.displayName = "Body48";

export const Body40 = styled.div`
  ${typography.Body40}
`;
Body40.displayName = "Body40";

export const Body32 = styled.div`
  ${typography.Body32}
`;
Body32.displayName = "Body32";

export const Body24 = styled.div`
  ${typography.Body24}
`;
Body24.displayName = "Body24";

export const Body19 = styled.div`
  ${typography.Body19}
`;
Body19.displayName = "Body19";

export const Body16 = styled.div`
  ${typography.Body16}
`;
Body16.displayName = "Body16";

export const Body14 = styled.div`
  ${typography.Body14}
`;
Body14.displayName = "Body14";

export const Body12 = styled.div`
  ${typography.Body12}
`;
Body12.displayName = "Body12";
